import { useNavigate } from "react-router-dom";
import '../../Pages/Pricing/Pricing.css'
import { usePageSeo } from "../../Hooks/usePageSeo";

const PageSmall = (props: any) => {
    const cssClass = "Page PageSmall " + props.className;

    usePageSeo(props);

    return <div className={cssClass}>
        {props.children}
    </div>
};

export default PageSmall;